/**
 * Turns the result of applying a discount code into a message that says what
 * actually happened.
 *
 * Codes are scoped to the "Full Price" collection, so during a sale a perfectly
 * valid code can apply to nothing. Before this, both the cart drawer and the cart
 * page reported that as "Invalid discount code" — telling customers their working
 * code was broken, which is where the support tickets came from.
 *
 * Three outcomes worth distinguishing:
 *   applied, no sale items   -> plain success
 *   applied, some sale items -> success, but say why it is smaller than expected
 *   not applied, all on sale -> the code is fine, these items are excluded
 *
 * Anything else falls through to a genuine "invalid code".
 */
/**
 * Whether the code the customer just entered is the one now on the cart.
 *
 * Checking merely for the presence of a discount chip is not enough: a cart can
 * already carry a discount, and Shopify applies one code at a time, so a
 * rejected code would look like a success. Discount chips render the code as
 * their title (see the .discounts__discount markup in cart-drawer.liquid and
 * main-cart-footer.liquid), so match on that instead.
 *
 * @param {ParentNode} root  document, or the freshly-fetched drawer subtree
 * @param {string} code      the code the customer submitted
 */
window.discountCodeApplied = function (root, code) {
  if (!root || !code) return false;

  var wanted = String(code).trim().toUpperCase();
  var chips = root.querySelectorAll('.discounts__discount');

  for (var i = 0; i < chips.length; i++) {
    if ((chips[i].textContent || '').toUpperCase().indexOf(wanted) !== -1) {
      return true;
    }
  }
  return false;
};

window.describeDiscountOutcome = function (form, hasDiscount) {
  var saleItems = 0;
  var fullPriceItems = 0;

  if (form) {
    saleItems = parseInt(form.getAttribute('data-sale-items'), 10) || 0;
    fullPriceItems = parseInt(form.getAttribute('data-full-price-items'), 10) || 0;
  }

  if (hasDiscount) {
    if (saleItems > 0) {
      return {
        text:
          'Applied to your ' +
          fullPriceItems +
          (fullPriceItems === 1 ? ' full-price item' : ' full-price items') +
          '. Sale items are excluded.',
        isError: false,
      };
    }
    return { text: 'Discount code applied.', isError: false };
  }

  // Valid code, but nothing in the cart is eligible.
  if (saleItems > 0 && fullPriceItems === 0) {
    return {
      text: "This code can't be combined with sale prices.",
      isError: true,
    };
  }

  return { text: 'Invalid discount code. Please try again.', isError: true };
};
